import {convertArrayToObject} from "../../helpers/utils";

export default {
  excelLayerList: (state) => state.excelLayerList,
  excelLayerColorList: (state) => state.excelLayerColorList,
  excelLayerColorMap: (state) => {
    return state.excelLayerColorList
      ? convertArrayToObject(state.excelLayerColorList, 'id')
      : {}
  },
  excelLayerSettings: (state) => state.excelLayerSettings,
  excelLayerObject: (state) => state.excelLayerObject,
  excelLayerObjectList: (state) => state.excelLayerObjectList,
  excelLayerIconList: (state) => state.excelLayerIconList,
}



// WEBPACK FOOTER //
// ./src/store/excel-layers/getters.js